
    // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';  //local 
    // const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.33:8000/api';

    const API_BASE_URL = process.env.REACT_APP_API_URL || ' https://billingapi.svmsweets.com/api'; // live

    export default API_BASE_URL;
